import { createSlice } from "@reduxjs/toolkit";
import { fetchUserData } from "./thunk";
import { UserDataSlice } from "types/users";

const initialState: UserDataSlice = {
    users: {},
    error: null,
    loading: true
}

const userDataSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchUserData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchUserData.fulfilled, (state, action) => {
            state.users[action.payload.uuid] = {
                user: action.payload,
                last_fetched_at: Date.now()
            }
            state.loading = false;
            state.error = null;
        })
        .addCase(fetchUserData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Failed to fetch user data';
        })
    }
})

export default userDataSlice.reducer;